import { CommodityGroup } from '@/generated/gql/graphql';

export enum CommodityGroupDataGridField {
  NAME = 'name',
  DESCRIPTION = 'description',
  ORDER_COUNT_CURRENT_YEAR = 'orderCountCurrentYear',
  ORDER_VOLUME_CURRENT_YEAR = 'orderVolumeCurrentYear',
  ORDER_COUNT_LAST_YEAR = 'orderCountLastYear',
  ORDER_VOLUME_LAST_YEAR = 'orderVolumeLastYear',
  ORDER_COUNT_LAST_12_MONTHS = 'orderCountLast12Months',
  ORDER_VOLUME_LAST_12_MONTHS = 'orderVolumeLast12Months',
  ORDER_VOLUME_SHARE_CURRENT_YEAR = 'orderVolumeShareCurrentYear',
  ORDER_VOLUME_SHARE_LAST_YEAR = 'orderVolumeShareLastYear',
  ORDER_VOLUME_SHARE_LAST_12_MONTHS = 'orderVolumeShareLast12Months',
  ORDER_VOLUME_CUMULATIVE_CURRENT_YEAR = 'orderVolumeCumulativeCurrentYear',
  ORDER_VOLUME_CUMULATIVE_LAST_YEAR = 'orderVolumeCumulativeLastYear',
  ORDER_VOLUME_CUMULATIVE_LAST_12_MONTHS = 'orderVolumeCumulativeLast12Months',
  LINKS = 'links',
}

export enum CommodityGroupDataGridColumnGroup {
  COMMODITY_GROUP = 'commodityGroup',
  ORDER = 'order',
}

export type CommodityGroupDataGridRow = CommodityGroup;
